import { render, staticRenderFns } from "./dvn_result.vue?vue&type=template&id=559b4fda&scoped=true"
import script from "./dvn_result.vue?vue&type=script&lang=js"
export * from "./dvn_result.vue?vue&type=script&lang=js"
import style0 from "./dvn_result.vue?vue&type=style&index=0&id=559b4fda&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b4fda",
  null
  
)

export default component.exports